import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ListItem } from 'telia-front-react';

import { InvoiceFileType } from '../../../services/ApiService';
import InvoiceFileStore from '../../../stores/InvoiceFileStore';
import { IInvoiceDetailsRequest } from '../../../stores/models/IInvoiceDetailsRequest';
import { ITranslateStore } from '../../../stores/TranslateStore';
import LinkButton from '../../common/LinkButton';

interface IDownloadFileButtonProps {
  invoiceDetailsRequest: IInvoiceDetailsRequest;
  invoiceFileType: InvoiceFileType;
  invoiceFileStore?: InvoiceFileStore;
  translateStore?: ITranslateStore;
}

@inject('invoiceFileStore', 'translateStore')
@observer
export default class DownloadFileButton extends React.Component<IDownloadFileButtonProps> {
  public render(): JSX.Element {
    const store = this.props.invoiceFileStore;
    const invoiceDetailsRequest = this.props.invoiceDetailsRequest;
    const invoiceFileType = this.props.invoiceFileType;
    const fileExtension = store.getFileExtensionFromInvoiceFileType(invoiceFileType);
    const translate = this.props.translateStore.translate;
    const file = store.getFile(invoiceFileType, invoiceDetailsRequest.invoiceNumber);

    let icon;

    if (file.isFinishedWithError) {
      icon = '#alert';
    } else if (fileExtension === 'PDF') {
      icon = '#file-pdf';
    } else {
      icon = '#file';
    }

    const defaultProps = {
      id: `invoice-details-header-${invoiceFileType}-download-button`,
      link: true,
      className: 'text-color-normal',
      text: translate(`shared.invoice-details-modal.header.download-file.${invoiceFileType}`)
    };

    const externalDownloadProps = {
      onClick: () => {
        store.downloadFile(invoiceDetailsRequest, invoiceFileType, 'API_REQUEST');
      },
      isLoading: file.isLoading,
      ...defaultProps
    };

    const nativeDownloadProps = {
      onClick: () => {
        store.downloadFile(invoiceDetailsRequest, invoiceFileType, 'URL');
      },
      ...defaultProps
    };

    return (
      <ListItem icon={icon}>
        <LinkButton
          gaEvent={`Link - download ${invoiceFileType}`}
          buttonProps={store.useNativeDownload(invoiceFileType) ? nativeDownloadProps : externalDownloadProps}
        />
      </ListItem>
    );
  }
}
